var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.988 11.117c0 1.177-.886 2.118-2.309 2.118h-.026c-1.37 0-2.255-.941-2.255-2.118C8.398 9.915 9.311 9 10.706 9c1.396 0 2.255.915 2.282 2.117zm-.27 3.791v12.257H8.64V14.908h4.079zM27.43 27.165v-7.028c0-3.764-2.012-5.516-4.697-5.516-2.166 0-3.135 1.19-3.677 2.024v-1.736h-4.08c.054 1.15 0 12.256 0 12.256h4.08V20.32c0-.366.027-.732.135-.994.294-.732.966-1.49 2.093-1.49 1.476 0 2.067 1.125 2.067 2.772v6.557h4.079z",
    fill: "#0077B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIN.cb48ef7d9c387bbee0cef2cb2427b1ba.svg";
export { ForwardRef as ReactComponent };